import React from "react";
import { LANDING } from "@/constants/testIds";

const Hero = ({ onRequestAccess, onExplore }) => {
  return (
    <section
      id="top"
      data-testid={LANDING.hero}
      className="relative min-h-screen flex flex-col justify-end overflow-hidden kr-atmosphere"
    >
      {/* Background video — seamless loop */}
      <video
        aria-hidden="true"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover opacity-[0.55] pointer-events-none"
      >
        <source src="/video/hero-background.mp4" type="video/mp4" />
      </video>

      {/* Dark wash overlay — preserves legibility over the video */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(10,13,18,0.78) 0%, rgba(10,13,18,0.55) 38%, rgba(10,13,18,0.85) 100%)",
        }}
      />

      {/* Background grid + soft light */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(28,34,48,0.22) 1px, transparent 1px), linear-gradient(90deg, rgba(28,34,48,0.22) 1px, transparent 1px)",
          backgroundSize: "84px 84px",
          maskImage:
            "radial-gradient(ellipse at 50% 30%, black 30%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at 50% 30%, black 30%, transparent 80%)",
        }}
      />
      <div
        aria-hidden
        className="absolute -top-32 -right-32 w-[680px] h-[680px] rounded-full opacity-[0.14] blur-[120px]"
        style={{
          background:
            "radial-gradient(circle, rgba(201,169,110,0.55), transparent 70%)",
        }}
      />
      <div
        aria-hidden
        className="absolute bottom-0 left-0 right-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, var(--kr-line) 30%, var(--kr-line) 70%, transparent)",
        }}
      />

      <div className="relative z-10 max-w-[1480px] w-full mx-auto px-6 lg:px-12 pt-40 pb-16">
        {/* Eyebrow */}
        <div className="flex items-center gap-4 mb-12">
          <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
            01
          </span>
          <span className="w-12 h-px bg-[var(--kr-gold)]/60" />
          <span className="font-mono-label text-[11px] text-[var(--kr-text-muted)]">
            Kellermann Reid &amp; Co. · Private Markets Platform
          </span>
        </div>

        {/* Headline */}
        <h1
          data-testid={LANDING.heroHeadline}
          className="font-serif-display text-[var(--kr-text)] text-[clamp(2.6rem,7vw,6.4rem)] max-w-[20ch]"
        >
          Private Markets.{" "}
          <span className="text-[var(--kr-gold)] italic">Industrial</span>{" "}
          Capital. Strategic Execution.
        </h1>

        {/* Sub */}
        <div className="mt-12 grid lg:grid-cols-12 gap-10 items-end">
          <p
            data-testid={LANDING.heroSub}
            className="lg:col-span-7 text-[var(--kr-text-muted)] text-[17px] leading-[1.75] max-w-[58ch]"
          >
            Kellermann Reid &amp; Co. is a private markets platform in strategic
            formation, focused on industrial credit, bridge opportunities,
            opportunistic equity and structured capital solutions for
            asset-backed and cash-flow supported situations.
          </p>

          <div className="lg:col-span-5 flex flex-wrap gap-4 lg:justify-end">
            <button
              type="button"
              onClick={onRequestAccess}
              data-testid={LANDING.heroCtaPrimary}
              className="kr-btn-primary"
            >
              Request Investor Access
              <span aria-hidden>→</span>
            </button>
            <button
              type="button"
              onClick={onExplore}
              data-testid={LANDING.heroCtaSecondary}
              className="kr-btn-ghost"
            >
              Explore Platform
            </button>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="mt-24 flex items-center gap-4 text-[var(--kr-text-muted)]">
          <span className="font-mono-label text-[10px]">Scroll</span>
          <span className="block w-16 h-px bg-[var(--kr-line)] relative overflow-hidden">
            <span
              className="absolute inset-y-0 left-0 w-1/3 bg-[var(--kr-gold)]"
              style={{
                animation: "kr-scroll 2.4s ease-in-out infinite",
              }}
            />
          </span>
        </div>
      </div>

      <style>{`
        @keyframes kr-scroll {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(180%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </section>
  );
};

export default Hero;
